import {
  TRAVELLER_DETAILS,
  TRAVELLER_DETAILS_ERRORS,
  COVERME_TRAVELLER_DETAILS,
  TravellerDetails,
  COVERME_ORIGINAL_TRAVELLER_DETAILS,
  TravellerDetailsActionPayload
} from './types';
import { RESET_STORE, STORE, TRANSLATE_DATE_FORMAT } from '../global';
import { checkWhitelist, isToTranslateDate } from '../reducer-utils';
import { dayjs } from '@trip-ux/common';
import { get, set } from 'lodash';

const initialState = {};

export const travellersDetails = (
  state: TravellerDetails = {},
  action: {
    type: string;
    payload?: TravellerDetailsActionPayload;
  }
): TravellerDetails => {
  const { formName, whitelist, ...payload } = action.payload ?? {};

  switch (action.type) {
    case TRAVELLER_DETAILS:
      return {
        ...state,
        formData: { ...state.formData, [formName]: payload }
      };
    case TRAVELLER_DETAILS_ERRORS:
      return { ...state, errors: { ...state.errors, [formName]: payload } };
    case COVERME_TRAVELLER_DETAILS:
      return {
        ...state,
        formData: { ...payload }
      };
    case COVERME_ORIGINAL_TRAVELLER_DETAILS:
      return {
        ...state,
        originalFormData: { ...payload }
      };
    case RESET_STORE:
      return checkWhitelist(whitelist, STORE.TRAVELLER_DETAILS, state, initialState);
    case TRANSLATE_DATE_FORMAT: {
      const previousDateFormat = get(payload, 'previousDateFormat');
      if (isToTranslateDate(previousDateFormat, state, 'originalFormData')) {
        const travellerCount = get(state, 'originalFormData.travellerCount');
        const currentDateFormat = get(payload, 'dateFormat');
        const dobFormatDate = {};
        // @ts-ignore
        for (let i = 1; i <= travellerCount; i++) {
          const dob = get(state, `originalFormData.dob${i}`);
          // @ts-ignore
          dobFormatDate['dob' + i] = dayjs(dob, previousDateFormat).format(currentDateFormat);
        }
        return set(state, 'originalFormData', { ...state.originalFormData, ...dobFormatDate });
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};
